import React from 'react';
import clsx from 'clsx';
import {
  Colors,
  ColorsType,
  FontSize,
  FontWeight,
  LineHeight,
  Radius,
  Spacing,
} from '@common/tokens';
import { getReadableTextColor } from './_tag-service';

type TagProps = {
  children: React.ReactNode;
  /** Background color token. */
  color: ColorsType;
  /**
   * Text color token. When omitted, a readable color is derived from the
   * background's luminance (dark text on light backgrounds, white on dark).
   */
  textColor?: ColorsType;
  /**
   * `pill` is the classic rounded tag; `square` is a compact square-cornered variant
   * (smaller radius, medium weight, tight padding) for inline metric/delta readouts.
   */
  kind?: 'pill' | 'square';
};

export const Tag = ({
  children,
  color,
  textColor = getReadableTextColor(color),
  kind = 'pill',
  ...props
}: TagProps) => {
  return (
    <>
      <span className={clsx('wk-tag', `wk-tag--${kind}`)} {...props}>
        {children}
      </span>
      <style jsx>{`
        .wk-tag {
          display: inline-block;
          white-space: nowrap;
          color: ${Colors[textColor]};
          background-color: ${Colors[color]};
          font-size: ${FontSize.xs};
          line-height: ${LineHeight.sm};
          border: 1px solid transparent;
        }
        .wk-tag--pill {
          border-radius: 12px;
          font-weight: ${FontWeight.bold};
          padding: 0 8px;
        }
        .wk-tag--square {
          border-radius: ${Radius.sm};
          font-weight: ${FontWeight.medium};
          padding: ${Spacing.xxs}px ${Spacing.sm}px;
        }
      `}</style>
    </>
  );
};
